export const adultsQtyMapper = (hotelInformationOccupation) => {
  switch (hotelInformationOccupation) {
    case '0100':
      return 1;
    case '0200':
      return 2;
    case '0300':
      return 3;
    default:
      return 0;
  }
};
